import { type FC, useContext } from 'react';

import { specContractRequirenments } from '@/common/config/contract';
import { specContractModalsName } from '@/common/constants/contract';
import { type SpecContractType } from '@/common/types/contract';
import { SpecContractItem } from '@/components/Contract/SpecContractItem/SpecContractItem';
import { ModalContext } from '@/components/Modals/Modal/config';
import { selectTutorialByKind } from '@/redux/selectors/userSelectors';
import { useAppSelector } from '@/redux/store';

import { ContractItemAnimationWrapper } from '../ContractItemAnimationWrapper/ContractItemAnimationWrapper';

import './styles.scss';

interface ContractSoonProps {
  kind: SpecContractType;
  isUninitialized: boolean;
  withDefaultContracts: boolean;
  userLevel: number;
}

const ContractSoon: FC<ContractSoonProps> = ({
  kind,
  isUninitialized,
  withDefaultContracts,
  userLevel,
}) => {
  const { openModal } = useContext(ModalContext);
  const aboutInfoWasRead = useAppSelector((state) =>
    selectTutorialByKind(state, kind),
  );

  const openAboutModal = (): void => {
    openModal({
      renderKind: specContractModalsName[kind],
      props: { status: 'forViewing', kind },
    });
  };
  const reqLevel = specContractRequirenments[kind].level;

  return (
    withDefaultContracts &&
    aboutInfoWasRead &&
    userLevel < reqLevel && (
      <ContractItemAnimationWrapper isUninitialized={isUninitialized}>
        <SpecContractItem
          kind={kind}
          status="lock"
          requairedLevel={reqLevel}
          timeLeft={null}
          contractTimerExtensionDuration={null}
          onClick={openAboutModal}
        />
      </ContractItemAnimationWrapper>
    )
  );
};

export { ContractSoon };
